
({
	events: [],
	init() {
		this.processQueue();
		this.initJsClickHandler();
		this.initJsPingHandler();
		this.initConversionHandler();
		this.initConversionPauser();
		this.initReadMore();
	},
	processQueue() {
		while (window.$ready.callbacks.length > 0) {
			const callback = window.$ready.callbacks.shift();
			if (typeof callback === 'function') {
				callback(this);
			}
		}
		window.$ready = (next) => {
			if (typeof next === 'function') {
				next(this);
			}
		};
	},
	initJsClickHandler() {
		this.addEventListener('click', '[js-href]', (event, target) => {
			event.preventDefault();
			const href = target.getAttribute('js-href');
			const isBlankTarget = target.getAttribute('js-target') === '_blank';
			if (isBlankTarget) {
				window.open(href, '_blank', 'noopener');
			} else {
				document.location.href = href;
			}
		});
	},
	initJsPingHandler() {
		(['click', 'touchstart', 'touchend', 'mousedown']).forEach(event => {
			let triggers = [];
			this.addEventListener(event, '[js-ping-' + event + ']', (e, target) => {
				const href = target.getAttribute('js-ping-' + event);
				if (href && !triggers.includes(href)) {
					this.ping(href);
					triggers.push(href);
				}
			});
		});
	},
	initConversionHandler() {
		this.addEventListener('click', '[data-conversion]', (event, target) => {
			let conversionData = null;
			try {
				conversionData = JSON.parse(target.getAttribute('data-conversion'));
			} catch (error) {
				console.error('Failed to parse conversion data:', error);
			}
			this.emit('conversion', conversionData, event, target);
		});
	},
	initConversionPauser() {
		let vTimeoutId = null;
		this.on('conversion', (conversionData, event, target) => {
			document.body.style.visibility = 'hidden';
			document.body.style.overflow = 'hidden';
			clearTimeout(vTimeoutId);
			vTimeoutId = setTimeout(function () {
				document.body.style.visibility = 'visible';
				document.body.style.overflow = 'auto';
			}, 15000);
		});
		this.addEventListener('visibilitychange', document, (event) => {
			document.body.style.visibility = 'visible';
			document.body.style.overflow = 'auto';
			clearTimeout(vTimeoutId);
		});
		this.addEventListener(['pageshow', 'pagehide', 'focus', 'blur'], window, (event) => {
			document.body.style.visibility = 'visible';
			document.body.style.overflow = 'auto';
			clearTimeout(vTimeoutId);
		});
	},
	initReadMore() {
		this.addEventListener('click', '[rm-trigger]', (event, target) => {
			event.preventDefault();
			document.querySelectorAll('[rm-content]').forEach((item) => {
				item.removeAttribute('rm-content');
			});
			document.querySelectorAll('[rm-trigger-container]').forEach((item) => {
				item.remove();
			});
			document.querySelectorAll('[rm-trigger]').forEach((item) => {
				item.remove();
			});
		});
	},
	on(event, callback) {
		this.events.push({
			event: event,
			callback: callback
		});
		return this;
	},
	one(event, callback) {
		let eventObject = {
			event: event,
			callback: (...args) => {
				this.events = this.events.filter((item) => item !== eventObject);
				callback(...args);
			}
		};
		this.events.push(eventObject);
		return this;
	},
	emit(event, ...args) {
		this.events.forEach((item) => {
			if (item.event === event) {
				item.callback(...args);
			}
		});
		return this;
	},
	addEventListener(event, selector, callback) {
		if (event instanceof Array) {
			event.forEach((e) => {
				this.addEventListener(e, selector, callback);
			});
			return this;
		}
		if (typeof selector === 'object') {
			selector.addEventListener(event, (e) => {
				return callback(e, selector);
			});
		}
		else {
			document.body.addEventListener(event, (e) => {
				const target = e.target.closest(selector);
				if (target) {
					return callback(e, target);
				}
			});
		}
		return this;
	},
	ping(url) {
		if (window.navigator.sendBeacon) {
			if (!window.navigator.sendBeacon(url)) {
				this.pingWithXHR(url);
			}
		} else {
			this.pingWithXHR(url);
		}
	},
	pingWithXHR(url) {
		try {
			const xhr = new XMLHttpRequest();
			xhr.open('POST', url, true);
			xhr.setRequestHeader('Content-Type', 'text/plain');
			xhr.send('');
		} catch (error) {
			console.error('Failed to send ping with XMLHttpRequest:', error);
		}
	},
	injectScript(src, callback) {
		let script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = src;
		if (typeof callback === 'function') {
			script.onload = callback.bind(this);
			script.onerror = callback.bind(this);
		}
		document.getElementsByTagName('head')[0].appendChild(script);
	}
}).init();